import React from 'react';

export default function HeatMapBlock(props) {

  let { item, isSchool, xsList, getElements, EditDetailsFn } = props;


  let ParaNameList = []
  let insertData = []

  let max = 0;

  let list = []
  if (item && item.dimensions && item.dimensions.length > 0) {
    item.dimensions.forEach((ele) => {

      if (max < ele.finalSum) {
        max = ele.finalSum
      }

      list.push(ele)
      ParaNameList.push(ele.name)
      insertData.push({
        value: ele.finalSum,
        itemStyle: {
          color: ele.colorCode
        }
      })

    })
  }

  if (list && list.length > 0) {
    list.sort((b, a) => (a.finalSum - b.finalSum))
  }


  function getValue(dimension) {
    let temp = {
      "rank": "",
      "count": 0,
      "color": '#757575'
    }
    if (list && list.length > 0) {
      let index = list.findIndex(prev => prev.name === dimension);
      if (index !== -1) {
        temp["rank"] = list[index]["rank"];
        temp["count"] = list[index]["count"];
        temp["color"] = list[index]["colorCode"];
      }
    }

    return temp
  }
  console.log("list----->", list)



  function hexToRgbA(hex, opacity) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split("");
      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = "0x" + c.join("");
      return (
        "rgba(" +
        [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
        "," +
        opacity +
        ")"
      );
    }
    throw hex;
  }


  function getValueX(ele, check2) {

    let blackColor = "#3D406B";
    let whiteColor = "#3D406B";

    if (ele && ele.bucket === "THINKING TALENTS") {
      blackColor = "#3D406B";
      whiteColor = "#3D406B"
    } else {
      whiteColor = "#ffffff"
    }

    let colorCode = "#3D406B";
    if (ele && ele.colorCode) {
      colorCode = ele.colorCode;
    }

    let tempXP = {
      "background": hexToRgbA(colorCode, '0.20'),
      "color": blackColor
    }
    if (check2 === 0) {
      tempXP["background"] = hexToRgbA(colorCode, '0.20');
      tempXP["color"] = blackColor;
    } else if (check2 === 1) {
      tempXP["background"] = hexToRgbA(colorCode, '0.20');
      tempXP["color"] = blackColor;
    } else if (check2 === 2) {
      tempXP["background"] = hexToRgbA(colorCode, '1');
      tempXP["color"] = whiteColor;
    } else if (check2 === 3) {
      tempXP["background"] = hexToRgbA(colorCode, '1');
      tempXP["color"] = whiteColor;
    } else if (check2 === 4) {
      tempXP["background"] = hexToRgbA(colorCode, '1');
      tempXP["color"] = whiteColor;
    }

    return tempXP
  }

  function getLightColor(bucket, isSchool) {
    let obj;
    if (isSchool) {
      obj = {
        "Thinking": "#FFF0C4",
        "Acting": "#CAE6FC",
        "Learning": "#DBD0EE",
        "Relating": "#D4ECD5",
        "Emotions": "#FFE6C2",
        "Communicating": "#C2EFF5"
      };
    } else {
      obj = {
        "THINKING TALENTS": "#FFF0C4",
        "ACTING TALENTS": "#CAE6FC",
        "LEADING TALENTS": "#DBD0EE",
        "RELATING TALENTS": "#D4ECD5"
      };
    }
    return obj && obj[bucket] ? obj[bucket] : "#F2F2F2"
  }

  return (
    <>

      <div class="">
        {list && list.length > 0 ?
          list.map((element) =>

            <>
              {element && element.rank && element.rank <= 5 ?
                <div className="pl-6 pb-1">
                  <div class="relative flex items-center py-3 bg-[#FFC400] text-black font-semibold text-lg pl-16 pr-12 w-full" style={{
                    background: hexToRgbA(
                      item && item.colorCode
                        ? item.colorCode
                        : "#DDDDDD",
                      element.rank <= 5 ? "1.0" : "0.24"
                    ),
                    color:
                      element.rank <= 5
                        ? item.bucket.trim() === "THINKING TALENTS"
                          ? "#3D405B"
                          : "#FFFFFF"
                        : "#3D405B",
                  }}>
                    <div class="absolute left-0 top-1/2 -translate-y-1/2 -ml-6">
                      <div class="w-14 h-14 bg-[#FFC400] rounded-full flex items-center justify-center text-black font-bold text-base border-4 border-white" style={{
                        background: hexToRgbA(
                          item && item.colorCode
                            ? item.colorCode
                            : "#DDDDDD",
                          element.rank <= 5 ? "1.0" : "0.24"
                        ),
                        color:
                          element.rank <= 5
                            ? item.bucket.trim() === "THINKING TALENTS"
                              ? "#3D405B"
                              : "#FFFFFF"
                            : "#3D405B",
                      }}>{element.rank}</div>
                    </div>
                    {EditDetailsFn(getElements(element.name, "dimension", xsList), "dimension", element.name)}
                  </div>
                </div>
                :
                <div className="pl-6 pb-1">
                  <div style={{
                    background: getLightColor(item.bucket, isSchool)
                  }} className={`relative flex items-center py-3 text-black font-semibold text-lg pl-16 pr-12 w-full`}>
                    <div className="absolute left-0 top-1/2 -translate-y-1/2 -ml-6">
                      <div style={{
                        background: getLightColor(item.bucket, isSchool)
                      }} className={`w-14 h-14  rounded-full flex items-center justify-center text-black font-bold text-base border-4 border-white`}>{element.rank}</div>
                    </div>
                    {EditDetailsFn(getElements(element.name, "dimension", xsList), "dimension", element.name)}
                  </div>
                </div>
              }
            </>
          )
          : null}

      </div>
    </>
  );
}
